// Prevent local PayPal sandbox script warnings from breaking development preview.
window.addEventListener("error", (event) => {
  if (String(event?.message || "").toLowerCase().includes("script error")) {
    event.preventDefault();
  }
});

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
